import Swiper, { Navigation, Pagination, EffectCoverflow } from 'swiper';

let normal_carousel = $('.category-carousel');
if (window.innerWidth < 600) {
    normal_carousel = normal_carousel.filter(':not(.list-on-mobile)');
}

normal_carousel.each((index, node) => {
    new Swiper(node, {
    	modules: [Navigation],
        slidesPerColumn: 2,
        spaceBetween: 16,
        autoHeight: false,
        autoplay:false,
        loop: false,

    	/*
    		Reminder: se questo viene messo a false, si spaccano i caroselli degli
    		episodi nelle serie (quantomeno, si spaccano passando da una stagione
    		all'altra, quando i relativi caroselli della stagione stessa viene
    		mostrato in pagina)
    	*/
        resizeObserver: true,

    	maxBackfaceHiddenSlides: 1000,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            600: {
                slidesPerView: 1,
                spaceBetween: 16,
            },
            700: {
                slidesPerView: 2,
                spaceBetween: 16,
            },
            900: {
                slidesPerView: 3,
                spaceBetween: 16,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 16,
            },
        },
    });
});

var carouselLarge = new Swiper('.carousel-large', {
	modules: [Navigation],
    slidesPerColumn: 3,
    spaceBetween: 16,
    autoplay:false,
    loop: false,
    resizeObserver: false,
	maxBackfaceHiddenSlides: 100,
    breakpoints: {
        600: {
            slidesPerView: 1,
            spaceBetween: 16,
        },
        1200: {
            slidesPerView: 3,
            spaceBetween: 16,
        },
    },
});

/*
	Articoli nella pagina dello sport.
	Ne vengono visualizzati 4 alla volta.
    Su mobile, gli articoli sono disposti verticalmente e senza carosello.
*/
if (window.innerWidth > 600) {
    var carouselArticles = new Swiper('.articles-carousel', {
        modules: [Navigation],
        slidesPerColumn: 4,
        slidesPerView: 4,
        spaceBetween: 16,
        autoHeight: true,
        autoplay:false,
        loop: false,
        resizeObserver: false,
        maxBackfaceHiddenSlides: 1000,
    });
}

/*
	Competizioni nella pagina dello sport.
	Ne vengono visualizzate 3 alla volta
*/
var carouselCompetitions = new Swiper('.competitions-carousel', {
	modules: [Navigation],
    slidesPerColumn: 2,
    spaceBetween: 16,
	autoHeight: true,
    autoplay:false,
    loop: false,
	resizeObserver: false,
	maxBackfaceHiddenSlides: 1000,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        600: {
            slidesPerView: 2,
            spaceBetween: 16,
        },
        1200: {
            slidesPerView: 3,
            spaceBetween: 16,
        },
    },
});

/*
	Articoli in evidenza nella pagina dello sport.
	Slide attiva centrata e paginazione
*/
var carouselHighlightArticles = new Swiper('.highlight-articles-carousel', {
	modules: [Navigation, Pagination],
    slidesPerColumn: 3,
    spaceBetween: 16,
    autoplay:false,
    loop: true,
	effect: "coverflow",
    resizeObserver: false,
	centeredSlides: true,
	maxBackfaceHiddenSlides: 1000,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        600: {
            slidesPerView: 1,
            spaceBetween: 5,
        },

		/*
			Questo breakpoint deve corrispondere alla larghezza della media
			query espressa nel mixin cursed-carousel-up
		*/
        1440: {
            slidesPerView: 3,
            spaceBetween: 16,
        },
    },
	pagination: {
		el: '.swiper-pagination',
		type: 'bullets',
	},
});

var swiper = new Swiper(".photo-gallery", {
	modules: [Navigation],
    slidesPerView: 3,
    spaceBetween: 30,
    centeredSlides: true,
	maxBackfaceHiddenSlides: 100,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});


(function (window){
    function isMobile() {
        return window.innerWidth < 1024
    }

    function initMostRequestedSwiper(){
        var mostRequestedSwiper = new Swiper("#most-requested", {
            modules: [EffectCoverflow],
            spaceBetween: 16,
            effect: "coverflow",
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: "auto",
			maxBackfaceHiddenSlides: 100,
            coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: false,
            }
        });
    }

    if (isMobile()){
        initMostRequestedSwiper()
    }

    const audioControls = $(".category-carousel .audio-control")
    audioControls.each((i, elem) => {
        const videoSelector = $('video', $(elem).parent())
        $(elem).on('click', function (){
            if (videoSelector.length > 0) {
                videoSelector.get(0).muted = !videoSelector.get(0).muted
                toggleAudio(videoSelector.get(0).muted, $(elem))
                console.log('video muted: ', videoSelector.get(0).muted)
            }
        })
    })
    var categoryListSwiper = new Swiper(".category-list-section-big > .carousel > .swiper-container", {
        slidesPerView: 'auto',
        spaceBetween: 16,
        centeredSlides: false,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            1024: {
                slidesPerView: 3,
                spaceBetween: 16
            },
            600: {
                slidesPerView: 2,
                spaceBetween: 16
            },
        },
    });
})(window)
